module.exports = __webpack_public_path__ + "static/img/desc.baf82f05.png";